import ReadMore from 'stimulus-read-more'

export default class extends ReadMore {

  static values = {updateSatisfactionUrl: String}

  connect() {
  }

  updateSatisfaction({params: {satisfaction}}) {
    fetch(this.updateSatisfactionUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({
        satisfaction: satisfaction,
      }),
    }).then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}
